import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DevUser {
  name: string;
  username: string;
  localAccountId: string;
}

interface DevAuthContextType {
  isAuthenticated: boolean;
  user: DevUser | null;
  login: () => void;
  logout: () => void;
  accounts: DevUser[];
}

const DevAuthContext = createContext<DevAuthContextType | undefined>(undefined);

export const useDevAuth = (): DevAuthContextType => {
  const context = useContext(DevAuthContext);
  if (!context) {
    throw new Error('useDevAuth must be used within a DevAuthProvider');
  }
  return context;
};

interface DevAuthProviderProps {
  children: ReactNode;
}

export const DevAuthProvider: React.FC<DevAuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<DevUser | null>(null);

  const login = (): void => {
    const mockUser: DevUser = {
      name: 'Development User',
      username: 'dev.user@example.com',
      localAccountId: 'dev-user-123'
    };
    setUser(mockUser);
    setIsAuthenticated(true);
    console.log('Development login successful');
  };

  const logout = (): void => {
    setUser(null);
    setIsAuthenticated(false);
    console.log('Development logout successful');
  };

  const value: DevAuthContextType = {
    isAuthenticated,
    user,
    login,
    logout,
    accounts: user ? [user] : []
  };

  return (
    <DevAuthContext.Provider value={value}>
      {children}
    </DevAuthContext.Provider>
  );
};
